import { defineMessages } from "react-intl";

export const i18n = defineMessages({
  logoutLabel: {
    defaultMessage: "Log out",
    id: "controls.logoutLabel",
  },
});
